/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$text-teaser-default-shadow: none !default;
$text-teaser-default-radius: 0 !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  text-align: left;
  font-family: $font-family-base;
  height: auto;
  box-shadow: $text-teaser-default-shadow;
  border-radius: $text-teaser-default-radius;

  @if $text-teaser-default-radius != 0 {
    overflow: hidden;
  }
}

:host([has-promo-flag]) {
  position: relative;
}

:host([promo-flag-sm]) {
  margin-top: 18px !important;

  .#{$prefix}text-teaser-wrapper {
    &.#{$prefix}promo-center,
    &.#{$prefix}promo-with-no-image {
      padding-top: 18px;
    }
  }
}

:host([promo-flag-lg]) {
  margin-top: 26px !important;

  .#{$prefix}text-teaser-wrapper {
    &.#{$prefix}promo-center,
    &.#{$prefix}promo-with-no-image {
      padding-top: 26px;
    }
  }
}

.#{$prefix}text-teaser-outer-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: v(contentBackgroundColor);
  box-sizing: border-box;

  &.#{$prefix}gradient {
    background: v(gradientColor);
  }
}

.#{$prefix}text-teaser-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  position: relative;
  height: 100%;
  box-sizing: border-box;
}

.#{$prefix}text-teaser-container {
  width: auto;
  height: 100%;
  padding: 48px;
}

.#{$prefix}text-teaser-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  eon-ui-headline {
    display: flex;
    flex-direction: column;
    color: v(valueTextColor);
  }

  .#{$prefix}pictogram-wrapper {
    eon-ui-pictogram {
      color: v(valueTextColor);
    }
  }

  &.#{$prefix}alignment-left {
    eon-ui-headline {
      align-items: flex-start;
    }

    ::slotted([slot="number"]) {
      --alignItems: flex-start;
    }
  }

  &.#{$prefix}alignment-right {
    eon-ui-headline {
      align-items: flex-end;
    }

    ::slotted([slot="number"]) {
      --alignItems: flex-end;
    }
  }

  &.#{$prefix}alignment-center {
    ::slotted([slot="number"]) {
      --alignItems: center;
    }
  }
}

.#{$prefix}text-teaser-number-content {
  eon-ui-pictogram {
    display: flex;
    justify-content: flex-end;
  }

  eon-ui-headline {
    text-align: right;
  }
}

eon-ui-pictogram,
eon-ui-headline,
.#{$prefix}number {
  z-index: 1;
  max-width: 100%;
}

.#{$prefix}content {
  max-width: 100%;
}

.#{$prefix}number,
.#{$prefix}pictogram-wrapper,
.#{$prefix}button-wrapper {
  &.#{$prefix}alignment-left {
    align-self: flex-start;
  }
  &.#{$prefix}alignment-center {
    align-self: center;
  }
  &.#{$prefix}alignment-right {
    align-self: flex-end;
  }
}

.#{$prefix}button-wrapper {
  width: 100%;
  &.#{$prefix}alignment-center {
    display: flex;
    justify-content: center;
  }
}

.#{$prefix}content {
  margin: 0;
  flex-grow: 1; // needed, when the text teaser is vertically strechted in the layout, the content panel should increase in size.
  font-size: 20px;
  font-weight: $font-weight-medium;
  line-height: 1.2;
  word-wrap: break-word; // For EDGE 18
  word-break: break-word; // For Chrome, Safari, Firefox
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  @include for-size(phone) {
    row-gap: 16px;
  }

  &.#{$prefix}alignment-left {
    text-align: left;
    align-items: flex-start;
  }

  &.#{$prefix}alignment-center {
    text-align: center;
    align-items: center;
  }

  &.#{$prefix}alignment-right {
    text-align: right;
    align-items: flex-end;
  }
}

@include teaserHeadlinesMargin(eon-ui-headline);

eon-ui-headline {
  margin-top: 8px;
  word-wrap: break-word; // For EDGE 18
  word-break: break-word; // For Chrome, Safari, Firefox

  &.#{$prefix}no-content {
    margin-bottom: 0px;
  }
}

@include for-size(desktop) {
  .#{$prefix}text-teaser-container {
    padding: 40px;
  }

  .#{$prefix}intro-section-text-wrapper {
    height: 58px;
  }
}

@include for-size(tablet) {
  .#{$prefix}text-teaser-container {
    padding: 32px;
  }

  .#{$prefix}intro-section-text-wrapper {
    height: 58px;
  }
}

@include for-size(phone) {
  .#{$prefix}text-teaser-container {
    padding: 24px;
  }

  .#{$prefix}intro-section-text-wrapper {
    height: 54px;
  }

  .#{$prefix}cta-component {
    margin-top: 24px;
  }
}

.#{$prefix}promo-flag {
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  max-width: calc(100% - 32px);
  z-index: 1;

  @include for-size(tablet) {
    max-width: calc(100% - 24px);
  }

  @include for-size(phone) {
    max-width: calc(100% - 16px);
  }

  &.#{$prefix}left {
    left: 0;
  }

  &.#{$prefix}right {
    right: 0;
  }

  &.#{$prefix}center {
    left: 0;
    width: 100%;
    max-width: none;
  }
}

::slotted(*) {
  color: v(contentColor);
}

::slotted([slot="button"]) {
  z-index: 1;
}

@include teaserCtaMargin("::slotted([slot=" button "])");

.#{$prefix}text-teaser-violator {
  display: flex;
  margin-top: 8px;
  margin-bottom: 16px;

  &.#{$prefix}left {
    justify-content: flex-start;
  }

  &.#{$prefix}right {
    justify-content: flex-end;
  }

  &.#{$prefix}center {
    justify-content: center;
  }
}

.#{$prefix}text-teaser-image {
  position: relative;

  .#{$prefix}text-teaser-violator {
    position: absolute;
    top: 32px;
    margin-top: 0;
    margin-bottom: 0;

    &.#{$prefix}left {
      left: 32px;
    }

    &.#{$prefix}right {
      right: 32px;
    }

    &.#{$prefix}center {
      left: 50%;
      transform: translateX(-50%);
    }

    @include for-size(phone) {
      top: 24px;

      &.#{$prefix}left {
        left: 24px;
      }

      &.#{$prefix}right {
        right: 24px;
      }
    }
  }
}

::slotted(eon-ui-link) {
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}
